// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const Collapse = ({ width, height, color }: Props) => (
  <svg
    viewBox="0 0 14 7"
    width={width || '100%'}
    height={height || '100%'}
    style={{ fill: color || 'currentColor' }}
  >
    <path
      d="M12.6571293,6.8904 C12.4951293,6.8904 12.3324627,6.83173333 12.203796,6.71306667 L6.653796,1.57573333 L1.119796,6.71173333 C0.850462666,6.96106667 0.428462666,6.9464 0.177796,6.67773333 C-0.0722040002,6.40706667 -0.0568706669,5.98573333 0.213129333,5.73573333 L6.19912933,0.177733333 C6.45512933,-0.0589333333 6.85046267,-0.0589333333 7.105796,0.177066667 L13.1104627,5.7344 C13.3804627,5.98506667 13.3964627,6.4064 13.1464627,6.67706667 C13.0151293,6.81906667 12.8364627,6.8904 12.6571293,6.8904"
      id="path-1"
    />
  </svg>
);
